module.exports = __webpack_public_path__ + "static/media/sc30_styleframe04_v001.97fd4db1.webp";